import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from 'Button';
import { Tooltip } from 'Tooltip';
import { faMicrophone } from '@fortawesome/pro-solid-svg-icons';
import { TUTOR_BOT_BUTTON_HEIGHT_NUM_12_5, type ToggleAudioOrTextConfig } from 'TutorBotConversation';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import '../locales/chat/chat-en.json';

function ToggleAudioOrTextButtonComponent({
    toggleAudioOrTextConfig,
    openToggleAudioOrTextTooltip = undefined, // storybook only
}: {
    toggleAudioOrTextConfig: NonNullable<ToggleAudioOrTextConfig>;
    openToggleAudioOrTextTooltip?: boolean | undefined;
}) {
    const { t } = useTranslation('back_royal');
    const { allowedMinutes, refreshDayOfWeek, refreshHour } = toggleAudioOrTextConfig.weeklyVoiceTimeLimitState || {};

    return (
        <Tooltip
            content={
                !toggleAudioOrTextConfig.canLaunchReviewPreviousMaterialAudio ? (
                    <span data-testid="toggle-audio-or-text-tooltip">
                        {t('chat.chat.you_have_used_your_voice_time', {
                            allowedMinutes,
                            refreshDayOfWeek,
                            refreshHour,
                        })}
                    </span>
                ) : null
            }
            multiline
            isDisabled={toggleAudioOrTextConfig.canLaunchReviewPreviousMaterialAudio}
            isOpen={openToggleAudioOrTextTooltip}
            placement="top-end"
        >
            {/*  If we don't have this span wrapping the button, then the fact that the button is disabled
                will prevent the tooltip from working */}
            <span className="inline-block" data-testid="toggle-audio-or-text-hover-element">
                <Button
                    isIconOnly
                    aria-label={t('chat.chat.toggle_audio_or_text')}
                    color="primary-gradient"
                    round
                    height={TUTOR_BOT_BUTTON_HEIGHT_NUM_12_5}
                    isDisabled={!toggleAudioOrTextConfig.canLaunchReviewPreviousMaterialAudio}
                    onPress={toggleAudioOrTextConfig.toggleAudioOrText}
                >
                    <FontAwesomeIcon icon={faMicrophone} />
                </Button>
            </span>
        </Tooltip>
    );
}

export const ToggleAudioOrTextButton = memo(
    ToggleAudioOrTextButtonComponent,
) as typeof ToggleAudioOrTextButtonComponent;
